import React from "react";

import { SelectInput, SelectInputProps } from "react-admin";
import {
  NETWORKTEAM_ADDIX,
  NETWORKTEAM_UNITED_DOMAINS,
  CUSTOMER,
} from "./domain-manager";

const roleValues = [NETWORKTEAM_ADDIX, NETWORKTEAM_UNITED_DOMAINS, CUSTOMER];

const DomainManagerSelectInput = (props: SelectInputProps) => {
  return (
    <SelectInput
      choices={roleValues.map((roleValue) => ({
        id: roleValue,
        name: `resources.Domain.domainManager.${roleValue}`,
      }))}
      {...props}
    />
  );
};
export default DomainManagerSelectInput;
